// Collar & Cuff Care — same behaviour as original HTML
// FAQ toggle
function toggleFaq(el) {
  const answer = el.nextElementSibling;
  const toggle = el.querySelector('.faq-toggle');
  const isOpen = answer.classList.contains('open');
  document.querySelectorAll('.faq-answer').forEach(a => a.classList.remove('open'));
  document.querySelectorAll('.faq-toggle').forEach(t => t.textContent = '+');
  if (!isOpen) {
    answer.classList.add('open');
    toggle.textContent = '−';
  }
}

(function () {
  // Scroll fade-in
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1 });

  const observeAll = (root) => root.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
  observeAll(document);

  // Theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', (e) => observeAll(e.target));

  // Nav scroll effect
  window.addEventListener('scroll', () => {
    const nav = document.querySelector('.ccc-nav');
    if (!nav) return;
    if (window.scrollY > 40) {
      nav.style.boxShadow = '0 4px 24px rgba(26,26,24,0.08)';
    } else {
      nav.style.boxShadow = 'none';
    }
  });
})();

// CCC Shop — realtime (AJAX) Add to Cart, opens Dawn cart drawer if enabled
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('.ccc-atc-form');
  if (!form) return;
  e.preventDefault();

  const btn = form.querySelector('.shop-btn, button[type="submit"]');
  if (!btn || btn.classList.contains('is-loading')) return;
  const label = btn.textContent;
  btn.classList.add('is-loading');

  const drawer = document.querySelector('cart-drawer');
  const body = new FormData(form);
  if (drawer) {
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);
  }

  try {
    const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || data.message || 'Error');

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ccc-shop', productVariantId: body.get('id'), cartData: data });
    }

    document.dispatchEvent(new CustomEvent('ccc:cart-updated'));
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
      btn.textContent = label;
    } else {
      btn.textContent = form.dataset.addedText || 'Added ✓';
      setTimeout(() => { btn.textContent = label; }, 2000);
    }
  } catch (err) {
    btn.textContent = err.message.length > 24 ? 'Error' : err.message;
    setTimeout(() => { btn.textContent = label; }, 2500);
  } finally {
    btn.classList.remove('is-loading');
  }
});

// CCC Videos — play only when visible, tap to toggle sound
(function () {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) { const p = target.play(); if (p) p.catch(() => {}); }
      else target.pause();
    });
  }, { threshold: 0.25 });

  const init = (root) => root.querySelectorAll('.ccc-video-card video').forEach(v => {
    v.muted = true; v.loop = true; v.playsInline = true;
    io.observe(v);
  });
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));

  document.addEventListener('click', (e) => {
    const card = e.target.closest('.ccc-video-card');
    if (!card) return;
    const v = card.querySelector('video');
    if (!v) return;
    const unmute = v.muted;
    document.querySelectorAll('.ccc-video-card video').forEach(x => { x.muted = true; });
    document.querySelectorAll('.ccc-video-sound').forEach(b => { b.textContent = '🔇'; });
    v.muted = !unmute;
    const btn = card.querySelector('.ccc-video-sound');
    if (btn) btn.textContent = v.muted ? '🔇' : '🔊';
    if (v.paused) v.play().catch(() => {});
  });
})();

// Mobile menu toggle
document.addEventListener('click', (e) => {
  const burger = e.target.closest('.ccc-burger');
  const nav = document.querySelector('.ccc-nav');
  if (!nav) return;
  if (burger) {
    const open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  } else if (e.target.closest('.nav-links a')) {
    nav.classList.remove('is-open');
  }
});

// Featured product: gallery thumbs + quantity
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('.ccc-feat-thumb');
  if (thumb) {
    const sec = thumb.closest('.ccc-feat');
    sec.querySelectorAll('.ccc-feat-slide').forEach(s => s.classList.toggle('is-active', s.dataset.index === thumb.dataset.index));
    sec.querySelectorAll('.ccc-feat-thumb').forEach(t => t.classList.toggle('is-active', t === thumb));
    return;
  }
  const q = e.target.closest('.ccc-qty-btn');
  if (q) {
    const input = q.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.dataset.step, 10));
  }
});
(function () {
  const initFeat = (root) => root.querySelectorAll('.ccc-feat').forEach(sec => {
    const first = sec.querySelector('.ccc-feat-slide');
    if (first && !sec.querySelector('.ccc-feat-slide.is-active')) first.classList.add('is-active');
    const t = sec.querySelector('.ccc-feat-thumb');
    if (t && !sec.querySelector('.ccc-feat-thumb.is-active')) t.classList.add('is-active');
  });
  initFeat(document);
  document.addEventListener('shopify:section:load', (e) => initFeat(e.target));
})();

// Header cart icon: open Dawn cart drawer + keep count in sync
(function () {
  const setCount = (n) => document.querySelectorAll('.ccc-cart-count').forEach(el => {
    el.textContent = n; el.hidden = !n;
  });
  const refresh = () => fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
    .then(r => r.json()).then(c => setCount(c.item_count)).catch(() => {});
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.ccc-cart');
    if (!link) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(link); }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  document.addEventListener('ccc:cart-updated', refresh);
  window.addEventListener('pageshow', refresh);
})();

// ── CCC Product Page: gallery, variants, sticky bar ──
(function () {
  const fmt = (cents) => (cents / 100).toFixed(2);

  function initPP(sec) {
    if (!sec || sec.dataset.cccInit) return;
    sec.dataset.cccInit = '1';
    const form = sec.querySelector('.ccc-pp-form');
    const idInput = sec.querySelector('[data-variant-input]');
    const atc = sec.querySelector('[data-atc]');
    const stickyBtn = sec.querySelector('[data-sticky-btn]');
    let variants = [];
    try { variants = JSON.parse(sec.querySelector('[data-variants]').textContent); } catch (e) {}

    const showMedia = (id) => {
      if (!id) return;
      sec.querySelectorAll('.ccc-pp-slide').forEach(s => s.classList.toggle('is-active', s.dataset.mediaId == id));
      sec.querySelectorAll('.ccc-pp-thumb').forEach(t => t.classList.toggle('is-active', t.dataset.mediaId == id));
    };

    // thumbnails
    sec.querySelectorAll('.ccc-pp-thumb').forEach(t => t.addEventListener('click', () => showMedia(t.dataset.mediaId)));

    // variant change
    sec.querySelectorAll('[data-option-index]').forEach(r => r.addEventListener('change', () => {
      const chosen = [];
      sec.querySelectorAll('.ccc-pp-option').forEach((fs, i) => {
        const c = fs.querySelector('input:checked'); chosen[i] = c ? c.value : null;
        const lab = sec.querySelector(`[data-option-label="${i}"]`); if (lab && c) lab.textContent = c.value;
      });
      const v = variants.find(v => v.options.every((o, i) => o === chosen[i]));
      const label = (key) => atc ? atc.dataset[key] : '';
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = label('textUnavailable'); }
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = label('textUnavailable'); }
        return;
      }
      idInput.value = v.id;
      sec.querySelectorAll('[data-price-now]').forEach(el => el.textContent = fmt(v.price));
      const was = sec.querySelector('[data-price-was]');
      if (was) { const on = v.compare_at_price && v.compare_at_price > v.price; was.hidden = !on; if (on) was.textContent = sec.dataset.currency + fmt(v.compare_at_price); }
      const txt = v.available ? label('textAdd') : label('textSoldout');
      if (atc) { atc.disabled = !v.available; atc.textContent = txt; }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = txt; }
      if (v.featured_media) showMedia(v.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }));

    // sticky mobile bar: show when main button is off screen
    const sticky = sec.querySelector('[data-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(atc);
    }
    if (stickyBtn && form) stickyBtn.addEventListener('click', () => {
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });
  }

  const initAll = (root) => root.querySelectorAll('.ccc-pp').forEach(initPP);
  initAll(document);
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
